import { render } from "./TheFinanceFixedAsset.vue?vue&type=template&id=dfcd7bfc&scoped=true"
import script from "./TheFinanceFixedAsset.vue?vue&type=script&lang=js"
export * from "./TheFinanceFixedAsset.vue?vue&type=script&lang=js"

import "./TheFinanceFixedAsset.vue?vue&type=style&index=0&id=dfcd7bfc&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfcd7bfc"]])

export default __exports__